var map;
var InfoObj = [];

var icons = {
  adoc: {
    icon: "https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909",
  },
};

var markersOnMap = [
  {
    storecode: "V01",
    placeName: "VANS Metrocentro San Salvador",
    storeAddress: "Centro Comercial Metrocentro San Salvador, 8a Etapa, Local 280 T, San Salvador, El Salvador",
    schedule: "Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm",
    phone: "22255820",
    whatsapp: "72752074",
    page: "https://maps.app.goo.gl/g1riZBMM3AMT4p5A6",
    review: "https://maps.app.goo.gl/g1riZBMM3AMT4p5A6/review",
    zona: 1,
    LatLng: [
      {
        lat: 13.70528599,
        lng: -89.2104749426,
      },
    ],
    type: "vans",
  },
 
];

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo() {
  for (var i = 0; i < markersOnMap.length; i++) {
    var contentString =
      '<div class="place-name">' + markersOnMap[i].placeName + "</div>";
    contentString +=
      '<div class="place-general">' + markersOnMap[i].storeAddress + "</div>";
    contentString +=
      '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
    if (markersOnMap[i].phone !== "")
      contentString +=
        '<div class="place-link"><a class="place-link" href="tel:+503' +
        markersOnMap[i].phone +
        '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
        markersOnMap[i].phone +
        "</a></div>";
    contentString +=
      '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
      markersOnMap[i].whatsapp +
      '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
      markersOnMap[i].whatsapp +
      "</a></div>";
    contentString +=
      '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
      markersOnMap[i].LatLng[0].lat +
      "%2C" +
      markersOnMap[i].LatLng[0].lng +
      '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
    if (markersOnMap[i].page !== "")
      contentString +=
        '<div class="place-link"><a class="place-link" target="_blank" href="' +
        markersOnMap[i].page +
        '">Ver mapa</a></div>';
    if (markersOnMap[i].review !== "")
      contentString +=
        '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
        markersOnMap[i].review +
        '">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map,
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    marker.addListener("click", function () {
      closeOtherInfo();
      infowindow.open(marker.get("map"), marker);
      InfoObj[0] = infowindow;
    });

    switch (markersOnMap[i].zona) {
      case 1:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info").innerHTML += contentDiv;
        break;

      case 2:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info2").innerHTML += contentDiv;
        break;

      case 3:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info3").innerHTML += contentDiv;
        break;

      case 4:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info4").innerHTML += contentDiv;
        break;

      default:
        var contentDiv =
          '<div class="contentDiv" onclick="SetCenterMap(' +
          markersOnMap[i].LatLng[0].lat +
          "," +
          markersOnMap[i].LatLng[0].lng +
          ')"><div class="place-name">' +
          markersOnMap[i].placeName +
          "</div>";
        contentDiv +=
          '<div class="place-general">' +
          markersOnMap[i].storeAddress +
          "</div>";
        contentDiv +=
          '<div class="place-general">' + markersOnMap[i].schedule + "</div>";
        if (markersOnMap[i].phone !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" href="tel:+503' +
            markersOnMap[i].phone +
            '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%"> (503)' +
            markersOnMap[i].phone +
            "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=503' +
          markersOnMap[i].whatsapp +
          '"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC El Salvador" style="width: 6%">(503)' +
          markersOnMap[i].whatsapp +
          "</a></div>";
        contentDiv +=
          '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll=' +
          markersOnMap[i].LatLng[0].lat +
          "%2C" +
          markersOnMap[i].LatLng[0].lng +
          '&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC El Salvador" style="width: 6%"> Navegar en Waze</a></div>';
        if (markersOnMap[i].page !== "")
          contentDiv +=
            '<div class="place-link"><a class="place-link" target="_blank" href="' +
            markersOnMap[i].page +
            '">Ver mapa</a></div>';
        if (markersOnMap[i].review !== "")
          contentDiv +=
            '<div class="place-link"><button class="button" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="' +
            markersOnMap[i].review +
            '">Agregar Reseña</a></button></div></div>';

        document.getElementById("add-info").innerHTML += contentDiv;
        break;
    }
  }
}

function closeOtherInfo() {
  if (InfoObj.length > 0) {
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon) {
  var centerStore = { lat: posLat, lng: posLon };
  map.setCenter(centerStore);
}

function positionOk(pos) {
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = { lat: latitudeMap, lng: longitudMap };
  map.setCenter(centerStore);
}

function positionKO() {
  const centerStore = { lat: 13.7063894, lng: -89.2124064 };
  map.setCenter(centerStore);
}

function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 15,
    center: { lat: 13.7063894, lng: -89.2124064 },
    mapId: "46642173f0d6b463",
  });

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);
  }

  addMarkerInfo();
}

function openPage(pageName, elmnt) {
  var i, tabcontent;

  tabcontent = document.getElementsByClassName("tabcontent2");

  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}
